module.exports = __webpack_public_path__ + "static/img/solutionDetailIcon01.817eb44.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionDetailIcon01.png
// module id = nd4Q
// module chunks = 0